import { render, staticRenderFns } from "./EditarEntradaModal.vue?vue&type=template&id=1489bf66"
import script from "./EditarEntradaModal.vue?vue&type=script&lang=js"
export * from "./EditarEntradaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports